export default function IconClose({ color = "#ffffff" }) {
  return (
    <svg width="16px" height="16px" viewBox="0 0 16 16" fill="none">
      <path
        d="M5.1716 8.00003L1.08582 3.91424L3.91424 1.08582L8.00003 5.1716L12.0858 1.08582L14.9142 3.91424L10.8285 8.00003L14.9142 12.0858L12.0858 14.9142L8.00003 10.8285L3.91424 14.9142L1.08582 12.0858L5.1716 8.00003Z"
        fill={color}
      />
    </svg>
  );
}
